// removed by extract-text-webpack-plugin
module.exports = {"PageHeader":"_3-AdpNooUzcNM9F2ynswZ7","PageHeader__inner":"_1wfEXBrvQX-8cSH1AGWEow","PageHeader__title":"snWhVPZjvioOTJxgm1-L0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/PageHeader.scss
// module id = 2669
// module chunks = 0